import { CSSProperties } from 'react';
import {
  DatePicker as MUIDatePicker,
  DatePickerProps as MUIDatePickerProps,
} from '@mui/x-date-pickers/DatePicker';
import { PickersActionBarAction } from '@mui/x-date-pickers/PickersActionBar';

import colors from '@atom/styles/colors';

import PickerTextField from './PickerTextField';

const styles = {
  pickerIcon: {
    color: colors.neutral.gray,
  },
};

type CustomProps = {
  hideClear?: boolean;
};

type AtomMUIProps = {
  value: Date;
  onChange: (date: Date) => void;
  onClick?: () => void;
  onBlur?: () => void;
  style?: CSSProperties;
  disabled?: boolean;
  label?: string;
  error?: boolean;
  helperText?: string;
  inputSx?: any;
  inputLabelSx?: any;
  shouldDisableDate?: (date: Date) => boolean;
  disableFuture?: boolean;
  'data-cy'?: string;
};

export type DatePickerPropsNew = CustomProps & AtomMUIProps;

export const DatePicker = (props: DatePickerPropsNew) => {
  const {
    error,
    helperText,
    inputSx,
    inputLabelSx,
    style,
    onClick,
    onBlur,
    hideClear,
    'data-cy': dataCy,
    ...data
  } = props;
  const MUIProps: MUIDatePickerProps = data;

  const actions: PickersActionBarAction[] = hideClear
    ? ['today', 'cancel']
    : ['today', 'cancel', 'clear'];

  return (
    <div style={{ width: '100%', ...style }}>
      <MUIDatePicker
        {...MUIProps}
        fullWidth
        slots={{ textField: PickerTextField }}
        slotProps={{
          actionBar: {
            actions,
            sx: { '& > button:first-of-type': { marginRight: 'auto' } },
          },
          textField: {
            fullWidth: true,
            error,
            helperText,
            onClick,
            onBlur,
            slotProps: {
              input: inputSx,
              inputLabel: inputLabelSx,
            },
            'data-cy': dataCy,
          } as any,
          openPickerIcon: {
            style: styles.pickerIcon,
          },
        }}
      />
    </div>
  );
};
